<template>
  <lu-vbox ref="bottomPanel" lu-flex :class="{show:bottomPanelOpened}" class="bottomPanel-container">

    <!-- <div class="bottomPanel-background" /> -->

    <lu-hbox class="bottomPanel">
      <div class="handle-button" :style="{'top':buttonTop+'px','background-color':theme}" @click="togglebottomPanel" sv-if='bottomPanelOpened'>
        <i class="el-icon-close" />
      </div>
      <lu-vbox lu-flex class="bottomPanel-items">

        <slot />
      </lu-vbox>
    </lu-hbox>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox } from 'lusis-ui'
import { addClass, removeClass } from '@/utils'
import { mapState } from 'vuex';

export default {
  name: 'BottomPanel',
  components: { LuHbox, LuVbox },
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    buttonTop: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      bottomPanelOpened: state => state.settingsMonitor.bottomPanelOpened
    }),
    theme() {
      return this.$store.state.settings.theme
    }
  },
  watch: {
    bottomPanelOpened(value) {
      if (value && !this.clickNotClose) {
        this.addEventClick()
      }
      if (value) {
        addClass(document.body, 'showbottomPanel')
      } else {
        removeClass(document.body, 'showbottomPanel')
      }
    }
  },
  mounted() {
    this.insertToBody()
  },
  beforeDestroy() {
    const elx = this.$refs.bottomPanel
    elx.remove()
  },
  methods: {
    addEventClick() {
      window.addEventListener('click', this.closeSidebar)
    },
    togglebottomPanel() {
      this.$store.dispatch('settingsMonitor/toggleBottomPanel', false)
    },
    closeSidebar(evt) {
      const parent = evt.target.closest('.bottomPanel')
      if (!parent) {
        // this.show = false
        window.removeEventListener('click', this.closeSidebar)
      }
    },
    insertToBody() {
      const elx = this.$refs.bottomPanel
      const body = document.querySelector('body')
      body.insertBefore(elx, body.firstChild)
    }
  }
}
</script>

<style>
.showbottomPanel {
  /* overflow: hidden; */
  position: relative;
  width: 100%;
  /* width: calc(100% - 150px); */
}
</style>

<style lang="scss" scoped>

.bottomPanel-background {
  position: fixed;
  bottom: 0;
  left: 0;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.7, .3, .1, 1);
  background: rgba(0, 0, 0, .2);
  z-index: -1;
}

.bottomPanel {
  width: 60%;
  min-width: 600px;
  position: fixed;
  top: 140px;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  // z-index: 40000;
  z-index: 100;
}


.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .bottomPanel-background {
    z-index: 20000;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .bottomPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}

</style>
